import { inject, injectable } from '@servicetitan/react-ioc';
import { ServiceAgreementsApi, ServiceAgreementStatus as AgreementStatus } from 'api';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { SpecialSettingsStore } from './special-settings.store';

@injectable()
export class ServiceAgreementStore {
    @observable serviceAgreementsExist = false;
    @observable loaded = false;

    constructor(
        @inject(ServiceAgreementsApi) private serviceAgreementsApi: ServiceAgreementsApi,
        @inject(SpecialSettingsStore) private readonly specialSettings: SpecialSettingsStore
    ) {
        makeObservable(this);
        this.loadServiceAgreementsExist();
    }

    @action async loadServiceAgreementsExist() {
        try {
            const serviceAgreementStatuses = await this.getStatusesFilter();
            this.serviceAgreementsExist =
                await this.serviceAgreementsApi.serviceAgreementsExist(serviceAgreementStatuses);
            runInAction(() => {
                this.loaded = true;
            });
        } catch {
            runInAction(() => {
                this.serviceAgreementsExist = true;
                this.loaded = true;
            });
        }
    }

    private async getStatusesFilter(): Promise<AgreementStatus[]> {
        const result = await this.specialSettings.getAsync<Record<string, boolean>>(
            'service-agreement-filter'
        );
        const statusMap: Record<string, AgreementStatus> = {
            sent: AgreementStatus.Sent,
            rejected: AgreementStatus.Rejected,
            accepted: AgreementStatus.Accepted,
            activated: AgreementStatus.Activated,
            canceled: AgreementStatus.Canceled,
            expired: AgreementStatus.Expired,
        };
        const statuses = Object.entries(statusMap)
            .filter(([key]) => result?.[key])
            .map(([, status]) => status);
        return statuses;
    }
}
